/*
  1221 · Consenso al tracciamento delle aperture email (CTRL+G, V1.26, 29 ottobre 2026)
  Linee guida del Garante privacy sui pixel di tracciamento nelle email (provv. n. 284 del 17 aprile 2026).

  Due punti d'uso:
  Caricato in layout/theme.liquid su tutte le pagine.
  1. Piede (sections/1221-footer.liquid, non modificato): la casella facoltativa, non spuntata, la aggiunge questo
     script sotto il campo della newsletter.
     All'invio registra in Klaviyo l'evento «Preferenza tracciamento aperture» con scelta si/no, testo e versione;
     se spuntata aggiunge anche il tag Shopify «tracciamento-aperture».
  2. Pagina «Preferenze di tracciamento» (sections/1221-preferenze-email.liquid, /pages/preferenze-email):
     il link «Gestisci le preferenze di tracciamento» in fondo alle email porta qui.
  In Klaviyo il flusso «1221 · Tracciamento aperture · Scelta» legge l'evento e aggiorna il consenso del profilo
  (subscriptions.email.open_tracking). Il consenso al tracciamento è separato da quello alla newsletter.
*/
(() => {
  if (window.x1221Tracciamento) return;
  window.x1221Tracciamento = true;
  /* V1.31 P4 (QA-112): l'ID pubblico Klaviyo viene da Impostazioni del tema › 1221 · Dati (window.x1221Dati, snippets/1221-head) */
  const KLAVIYO_ID = (window.x1221Dati && window.x1221Dati.klaviyo) || '';
  const VERSIONE = 'V1 · 29 ottobre 2026';

  /* V1.31 (QA-032): il profilo è { email } dal piede (chi si iscrive scrive la sua email) oppure { _kx } dalla pagina
     delle preferenze: _kx è l'identificativo cifrato che Klaviyo aggiunge ai link delle sue email. */
  const evento = (profilo, proprieta) => {
    const ctrl = 'AbortController' in window ? new AbortController() : null;
    const t = setTimeout(() => ctrl && ctrl.abort(), 4000);
    return fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_ID}`, {
      method: 'POST',
      keepalive: true,
      signal: ctrl ? ctrl.signal : undefined,
      headers: { 'Content-Type': 'application/json', revision: '2026-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: { ...proprieta, versione_testo: VERSIONE, pagina: location.origin + location.pathname },
            metric: { data: { type: 'metric', attributes: { name: 'Preferenza tracciamento aperture' } } },
            profile: { data: { type: 'profile', attributes: typeof profilo === 'string' ? { email: profilo } : profilo } }
          }
        }
      })
    }).then((r) => { clearTimeout(t); return r.ok; }).catch(() => { clearTimeout(t); return false; });
  };

  /* 1 · piede: la casella si aggiunge qui, sotto il campo email del modulo newsletter (#x-piede-newsletter).
     Senza JavaScript la casella non compare e non parte nessun consenso: le aperture restano non misurate. */
  const piede = document.getElementById('x-piede-newsletter');
  const campo = piede && piede.querySelector('.x-pd__campo');
  if (campo && !piede.querySelector('[data-x-traccia]')) {
    piede.setAttribute('data-x-traccia-form', '');
    const riga = document.createElement('label');
    riga.className = 'x-pd__traccia';
    riga.innerHTML =
      '<input type="checkbox" data-x-traccia>' +
      '<span data-x-traccia-testo>Facoltativo · Acconsento alla misurazione delle aperture delle email. ' +
      'Posso cambiare idea in ogni momento, dal link in fondo a ogni email.</span>';
    campo.insertAdjacentElement('afterend', riga);
    const css = document.createElement('style');
    css.textContent =
      '.x-pd__traccia{display:grid;grid-template-columns:16px 1fr;gap:.6rem;align-items:start;margin-block-start:.9rem;cursor:pointer}' +
      '.x-pd__traccia input{width:14px;height:14px;margin:3px 0 0;accent-color:#fff;cursor:pointer}' +
      '.x-pd__traccia span{font-size:12px;line-height:1.5;font-weight:300;color:rgb(255 255 255 / .7);text-align:left}';
    document.head.appendChild(css);
  }

  document.querySelectorAll('[data-x-traccia-form]').forEach((form) => {
    const casella = form.querySelector('[data-x-traccia]');
    const tag = form.querySelector('input[name="contact[tags]"]');
    const testo = form.querySelector('[data-x-traccia-testo]');
    if (!casella) return;
    /* V1.30 (30/10/2026, QA-008): l'invio del modulo non si ferma più. Il tag si scrive subito, l'evento Klaviyo parte con
       keepalive (arriva anche se la pagina cambia) e il modulo prosegue da solo: così la protezione hCaptcha di Shopify
       riceve l'invio come sempre. Prima: preventDefault, attesa e HTMLFormElement.prototype.submit, che la saltava. */
    form.addEventListener('submit', (e) => {
      if (e.defaultPrevented) return;
      const email = (form.querySelector('input[type="email"]') || {}).value;
      if (!email || !form.checkValidity()) return;
      const si = casella.checked;
      if (tag) tag.value = si ? 'newsletter, tracciamento-aperture' : 'newsletter';
      evento(email.trim(), {
        scelta: si ? 'si' : 'no',
        fonte: 'piede del sito · iscrizione newsletter',
        testo: testo ? testo.textContent.trim().replace(/\s+/g, ' ') : ''
      });
    }, true);
  });

  /* 2 · pagina delle preferenze
     V1.31 (30/10/2026, QA-032): niente più email nell'indirizzo (?e=) né campo email libero. La pagina riconosce chi
     arriva dal link in fondo alle email Klaviyo con il parametro firmato _kx (lo aggiunge Klaviyo ai link, impostazione
     «Tracciamento e-mail al sito web»). Il parametro si toglie subito dalla barra degli indirizzi e resta solo in questa
     scheda. Senza _kx la scelta non si può salvare: compare l'invito ad aprire il link da una nostra email. */
  document.querySelectorAll('[data-x-pref-form]').forEach((form) => {
    const esito = form.parentElement.querySelector('[data-x-pref-esito]');
    const senza = form.parentElement.querySelector('[data-x-pref-senza]');
    const bottone = form.querySelector('button[type="submit"]');
    const qs = new URLSearchParams(location.search);
    let kx = qs.get('_kx') || '';
    try { if (kx) sessionStorage.setItem('x1221-kx', kx); else kx = sessionStorage.getItem('x1221-kx') || ''; } catch (e) { /* scheda privata */ }
    if (qs.has('_kx') || qs.has('e')) {
      qs.delete('_kx');
      qs.delete('e');
      history.replaceState(history.state, '', location.pathname + (qs.toString() ? '?' + qs.toString() : '') + location.hash);
    }
    if (!kx) {
      form.hidden = true;
      if (senza) senza.hidden = false;
      return;
    }
    /* ?scelta=si|no dai pulsanti della campagna: la scelta arriva già selezionata */
    const pre = form.querySelector(`input[name="scelta"][value="${qs.get('scelta')}"]`);
    if (pre) pre.checked = true;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!form.reportValidity()) return;
      const scelta = (form.querySelector('input[name="scelta"]:checked') || {}).value;
      const etichetta = form.querySelector('input[name="scelta"]:checked + span');
      bottone.disabled = true;
      const ok = await evento({ _kx: kx }, {
        scelta,
        fonte: 'pagina Preferenze di tracciamento (link firmato da email)',
        testo: etichetta ? etichetta.textContent.trim() : ''
      });
      bottone.disabled = false;
      if (!esito) return;
      esito.hidden = false;
      esito.textContent = ok
        ? (scelta === 'si'
          ? 'Fatto: da ora vediamo quando apri le nostre email. Puoi cambiare idea da qui quando vuoi.'
          : 'Fatto: da ora non misuriamo più quando apri le nostre email. La newsletter continua ad arrivarti.')
        : 'Non siamo riusciti a salvare la scelta. Riprova fra poco o scrivici a ordini@donatellalucchi.com.';
      esito.focus();
    });
  });
})();
